import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PinTypeEnum } from '../../../../../enums/PinTypeEnum';
import { PopupService } from '../../../../../services/popup.service';
import { PinService } from '../../../../../services/pin.service';
import { LoaderService } from '../../../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { RemovedItemsService } from "../../../../../services/removed-items.service";
import { MyStuffService } from '../../../../../services/my-stuff.service';

@Component({
  selector: 'app-removed-pins',
  templateUrl: './removed-pins.component.html',
  styleUrls: ['./removed-pins.component.less']
})
export class RemovedPinsComponent implements OnInit {

  constructor(public popupService: PopupService, public pinService: PinService,
    public ref: ChangeDetectorRef, public loaderService : LoaderService, public removedItemsService : RemovedItemsService,
    public myStuffService: MyStuffService) { }

  pinsContainerElement: any;
  pinsInputElement: any;

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.deletedPins) {
      this.removedItemsService.fetchRemovedPinsSource.next(true);
      this.myStuffService.myStuffSectionOpened.deletedPins = true;
    }
  }

  ngAfterViewInit() {
    this.removedItemsService.removedPinsAddInputEventObservable();
  }

  getPinType(type) {
    if(type === PinTypeEnum.LABEL) {
      return 'label';
    } else if(type === PinTypeEnum.DOT) {
      return 'dot';
    } else if(type === PinTypeEnum.PIN) {
      return 'pin';
    } else if(type === PinTypeEnum.PIN_LABEL) {
      return 'pin with label';
    }
  }

  paginate() {
    this.removedItemsService.fetchDeletedPins();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/removed-items/removed-pins/removed-pins.component.ts